module.exports = __webpack_public_path__ + "img/default_centro.1e06602a.png";